<div class="header">
  <div class="header__content" routerLink="dashboard">
    <img
      class="header__logo"
      src="./assets/img/logo.svg"
      width="44"
      height="44"
      alt="logo"
    />
    <div
      [innerHTML]="'trader-navigation.header.title' | translate"
      class="header__title"
    ></div>
  </div>
</div>
<div class="menu">
  <div class="menu__block menu__block--static">
    <a
      class="menu__link"
      routerLink="dashboard"
      routerLinkActive="active"
      translate="trader-navigation.link.dashboard"
    ></a>
    <a
      class="menu__link"
      routerLink="finances"
      routerLinkActive="active"
      translate="trader-navigation.link.finances"
    ></a>
    <a
      class="menu__link"
      routerLink="rewards-hub"
      routerLinkActive="active"
      translate="trader-navigation.link.rewards-hub"
    ></a>
    <a
      class="menu__link"
      routerLink="content"
      routerLinkActive="active"
      translate="trader-navigation.link.analytics-and-education"
    ></a>
    <a
      href="https://fbs.helpcenter.io/{{language}}"
      class="menu__link"
      target="_blank"
      translate="trader-navigation.link.help-center"
    >
    </a>
  </div>
  <div class="menu__block menu__block--stretched">
    <div class="menu__block-segment">
      <a
        class="menu__link"
        routerLink="profile"
        routerLinkActive="active"
        translate="trader-navigation.link.profile"
      ></a>
      <a
        *ngIf="isPartner"
        class="menu__link"
        routerLink="partner/dashboard"
        routerLinkActive="active"
        translate="trader-navigation.link.to-partner-area"
        data-e2e-element="trader-navigation.link.to-partner-area"
      ></a>
      <a
        *ngIf="!isPartner"
        class="menu__link"
        routerLink="partner-join"
        routerLinkActive="active"
        data-e2e-element="trader-navigation.link.partner-join"
        translate="trader-navigation.link.partner-join"
      ></a>
    </div>
    <div class="menu__block-segment">
      <a
        class="menu__link"
        routerLink="logout"
        translate="trader-navigation.link.logout"
      ></a>
    </div>
  </div>
</div>
<div class="footer"></div>
